import React, { useState, useEffect } from 'react';
import { MdClose, MdBusiness, MdLocationOn, MdPhone, MdDateRange, MdCategory, MdPerson, MdEmail, MdHome, MdGroup, MdAssignment } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL, API_CONFIG } from '../../config/api';
import TraderLocationMap from '../../components/TraderLocationMap';

const ViewTraderModal = ({ isOpen, onClose, trader, onEdit }) => {
  const [traderDetails, setTraderDetails] = useState(null);
  const [loading, setLoading] = useState(false);



  // Fetch complete trader details from database
  const fetchTraderDetails = async (traderId) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/traders/${traderId}`, API_CONFIG);
      setTraderDetails(response.data);
    } catch (error) {
      console.error('Error fetching trader details:', error);
      setTraderDetails(trader); // Fallback to basic trader data
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && trader && trader.trader_id) {
      fetchTraderDetails(trader.trader_id);
    }
  }, [isOpen, trader]); // fetchTraderDetails is stable, no need to include

  if (!isOpen || !trader) return null;

  const displayTrader = traderDetails || trader;

  // Debug logging for location data
  console.log('ViewTraderModal - displayTrader:', displayTrader);
  console.log('Has latitude:', !!displayTrader.latitude);
  console.log('Has longitude:', !!displayTrader.longitude);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdBusiness size={24} style={{ color: '#ff9800' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Business Details</h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Business Profile Section */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: 20,
          borderRadius: 8,
          marginBottom: 20,
          display: 'flex',
          alignItems: 'center',
          gap: 20,
        }}>
          <div style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: '#ff9800',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <MdBusiness size={40} style={{ color: 'white' }} />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: '0 0 8px 0', color: '#333', fontSize: 22 }}>
              {displayTrader.business_name || 'Business Name Not Set'}
            </h3>
            <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: 14 }}>
              <strong>Trader ID:</strong> #{displayTrader.trader_id} |
              <strong> Owner:</strong> {displayTrader.owner_name || displayTrader.first_name + ' ' + (displayTrader.last_name || '')}
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span style={{
                padding: '4px 12px',
                backgroundColor: '#fff3e0',
                borderRadius: 16,
                fontSize: 12,
                fontWeight: 'bold',
                color: '#f57c00'
              }}>
                {displayTrader.business_type || 'GENERAL BUSINESS'}
              </span>
              <span style={{
                padding: '4px 8px',
                backgroundColor: displayTrader.status === 'active' ? '#e8f5e8' : '#ffebee',
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 'bold',
                color: displayTrader.status === 'active' ? '#2e7d32' : '#c62828'
              }}>
                {(displayTrader.status || 'active').charAt(0).toUpperCase() + (displayTrader.status || 'active').slice(1)}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 12, color: '#666' }}>
              {displayTrader.zone_name && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <MdLocationOn size={14} />
                  <span>{displayTrader.zone_name}</span>
                </div>
              )}
              {displayTrader.group_name && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <MdGroup size={14} />
                  <span>{displayTrader.group_name}</span>
                </div>
              )}
              {(displayTrader.latitude && displayTrader.longitude) && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  padding: '2px 6px',
                  backgroundColor: '#e8f5e8',
                  borderRadius: 12,
                  color: '#2e7d32'
                }}>
                  <MdLocationOn size={12} />
                  <span style={{ fontSize: 11, fontWeight: 'bold' }}>GPS Located</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Personal Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdPerson size={20} style={{ color: '#17a2b8' }} />
            Personal Information
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Owner Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.owner_name || 'Not provided'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>First Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.first_name || 'Not provided'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Middle Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.middle_name || 'Not provided'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Last Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.last_name || 'Not provided'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPhone size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Phone Number</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.phone || 'Not provided'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdEmail size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Email Address</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.email || 'Not provided'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdAssignment size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>ID Type</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.national_id_type_name || `ID Type ${displayTrader.id_type}` || 'Not specified'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdAssignment size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>National Info</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.national_info || 'Not provided'}</p>
            </div>
          </div>
        </div>

        {/* Business Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdBusiness size={20} style={{ color: '#ff9800' }} />
            Business Information
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdBusiness size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Business Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.business_name || 'Not specified'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdCategory size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Business Type</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{displayTrader.business_type || 'General'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdDateRange size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Registration Date</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.registration_date ?
                  new Date(displayTrader.registration_date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }) : 'Not specified'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdAssignment size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Business Status</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                <span style={{
                  padding: '2px 8px',
                  backgroundColor: displayTrader.status === 'active' ? '#e8f5e8' : '#ffebee',
                  borderRadius: 4,
                  fontSize: 12,
                  fontWeight: 'bold',
                  color: displayTrader.status === 'active' ? '#2e7d32' : '#c62828'
                }}>
                  {(displayTrader.status || 'active').charAt(0).toUpperCase() + (displayTrader.status || 'active').slice(1)}
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Location & Zone Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdLocationOn size={20} style={{ color: '#4caf50' }} />
            Location & Zone Information
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>

            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdLocationOn size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Zone Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.zone_name || 'Not assigned'}
              </p>
            </div>

            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdGroup size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Group Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.group_name || 'Not assigned'}
              </p>
            </div>
            {displayTrader.zone_description && (
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <MdLocationOn size={16} style={{ color: '#666' }} />
                  <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Zone Description</label>
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.5 }}>
                  {displayTrader.zone_description}
                </p>
              </div>
            )}
            {displayTrader.group_description && (
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <MdGroup size={16} style={{ color: '#666' }} />
                  <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Group Description</label>
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.5 }}>
                  {displayTrader.group_description}
                </p>
              </div>
            )}
          </div>
          {displayTrader.location && (
            <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #e0e0e0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdHome size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Business Address</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333', lineHeight: 1.5 }}>
                {displayTrader.location}
              </p>
            </div>
          )}



          {/* GPS Location Map */}
          {(displayTrader.latitude && displayTrader.longitude) && (
            <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #e0e0e0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <MdLocationOn size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>GPS Location</label>
              </div>

              <div style={{ marginBottom: 12 }}>
                <TraderLocationMap
                  latitude={displayTrader.latitude}
                  longitude={displayTrader.longitude}
                  address={displayTrader.location_address || displayTrader.location}
                  businessName={displayTrader.business_name}
                  accuracy={displayTrader.location_accuracy}
                  height={250}
                  showFullscreen={true}
                />
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: 12,
                padding: 12,
                backgroundColor: '#f8f9fa',
                borderRadius: 6,
                fontSize: 12,
                color: '#666'
              }}>
                <div>
                  <strong>Coordinates:</strong><br />
                  {parseFloat(displayTrader.latitude).toFixed(6)}, {parseFloat(displayTrader.longitude).toFixed(6)}
                </div>
                {displayTrader.location_accuracy && (
                  <div>
                    <strong>Accuracy:</strong><br />
                    ±{Math.round(displayTrader.location_accuracy)}m
                  </div>
                )}
                {displayTrader.location_created_at && (
                  <div>
                    <strong>Captured:</strong><br />
                    {new Date(displayTrader.location_created_at).toLocaleDateString()}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Administrative Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdAssignment size={20} style={{ color: '#9c27b0' }} />
            Administrative Information
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>


            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdBusiness size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>MMDA Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.mmda_name || 'Not specified'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdLocationOn size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>MMDA Region</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.mmda_region || 'Not specified'}
              </p>
            </div>

            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Created By Name</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.created_by_name || 'Unknown'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdEmail size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Created By Email</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.created_by_email || 'Not provided'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdDateRange size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Created Date</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.created_at ?
                  new Date(displayTrader.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  }) : 'Unknown'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdDateRange size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Last Updated</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {displayTrader.updated_at ?
                  new Date(displayTrader.updated_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  }) : 'Never updated'}
              </p>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 20,
            borderRadius: 8,
            marginBottom: 20,
            textAlign: 'center',
            border: '1px solid #e0e0e0',
          }}>
            <p style={{ margin: 0, color: '#666', fontSize: 14 }}>Loading complete trader details...</p>
          </div>
        )}

        {/* Business Description */}
        {displayTrader.description && (
          <div style={{
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: 8,
            padding: 20,
            marginBottom: 20,
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: 16 }}>Business Description</h3>
            <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.5 }}>
              {displayTrader.description}
            </p>
          </div>
        )}



        {/* MMDA Information */}
        <div style={{
          backgroundColor: '#e8f5e8',
          padding: 16,
          borderRadius: 8,
          marginBottom: 20,
          border: '1px solid #c8e6c9',
        }}>
          <h3 style={{ margin: '0 0 8px 0', color: '#2e7d32', fontSize: 14, fontWeight: 'bold' }}>
            MMDA Regional Business
          </h3>
          <p style={{ margin: 0, fontSize: 12, color: '#2e7d32' }}>
            This business is registered within your MMDA region. All database fields from the traders table and related
            tables are displayed above in organized sections. You have full access to view all business details,
            transaction history, and can manage business registration information.
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <button
            onClick={() => console.log('View transactions for:', displayTrader.business_name)}
            style={{
              padding: '10px 20px',
              border: '1px solid #28a745',
              borderRadius: 6,
              backgroundColor: 'white',
              color: '#28a745',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <MdDateRange size={16} />
            View Transactions
          </button>
          <button
            onClick={() => {
              onClose();
              onEdit && onEdit(displayTrader);
            }}
            style={{
              padding: '10px 20px',
              border: '1px solid #ff9800',
              borderRadius: 6,
              backgroundColor: 'white',
              color: '#ff9800',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <MdBusiness size={16} />
            Edit Business
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 6,
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewTraderModal;
